import { jsx as _jsx } from "react/jsx-runtime";
export const useExecutiveSummaryColumns = ({ viewSettings, kpiResult, }) => {
    const columns = [
        {
            key: "accountName",
            label: "Account Name",
            sortable: true,
            align: "left",
            render: (value, row) => (_jsx("span", { style: { fontWeight: row.isTotal ? "700" : "500" }, children: value })),
        },
    ];
    if (viewSettings.showPractices) {
        columns.push({
            key: "practices",
            label: "Practices",
            sortable: true,
            align: "center",
        });
    }
    if (viewSettings.showTotalInteractions) {
        columns.push({
            key: "totalInteractions",
            label: "Total Interactions",
            sortable: true,
            align: "center",
        });
    }
    if (viewSettings.showUrgent) {
        columns.push({
            key: "urgent",
            label: "Urgent",
            sortable: true,
            align: "center",
        });
    }
    if (viewSettings.showRoutine) {
        columns.push({
            key: "routine",
            label: "Routine",
            sortable: true,
            align: "center",
        });
    }
    if (viewSettings.showAvgUrgentReadTime) {
        columns.push({
            key: "avgUrgentReadTimeSeconds",
            label: "Avg Urgent Read Time",
            sortable: true,
            align: "center",
            render: (_, row) => row.avgUrgentReadTime,
        });
    }
    if (viewSettings.showMedianUrgentReadTime) {
        columns.push({
            key: "medianUrgentReadTimeSeconds",
            label: "Median Urgent Read Time",
            sortable: true,
            align: "center",
            render: (_, row) => row.medianUrgentReadTime,
        });
    }
    if (viewSettings.showAvgCallbackTime) {
        columns.push({
            key: "avgCallbackTimeSeconds",
            label: "Avg Callback Time",
            sortable: true,
            align: "center",
            render: (_, row) => row.avgCallbackTime,
        });
    }
    if (viewSettings.showMedianCallbackTime) {
        columns.push({
            key: "medianCallbackTimeSeconds",
            label: "Median Callback Time",
            sortable: true,
            align: "center",
            render: (_, row) => row.medianCallbackTime,
        });
    }
    if (viewSettings.showAvgCallbackDuration) {
        columns.push({
            key: "avgCallbackDurationSeconds",
            label: "Avg Callback Duration",
            sortable: true,
            align: "center",
            render: (_, row) => row.avgCallbackDuration,
        });
    }
    if (viewSettings.showMedianCallbackDuration) {
        columns.push({
            key: "medianCallbackDurationSeconds",
            label: "Median Callback Duration",
            sortable: true,
            align: "center",
            render: (_, row) => row.medianCallbackDuration,
        });
    }
    if (viewSettings.showCallbackCount) {
        columns.push({
            key: "callbackCount",
            label: "Callback Count",
            sortable: true,
            align: "center",
        });
    }
    if (viewSettings.showVoicemails) {
        columns.push({
            key: "voicemails",
            label: "Voicemails",
            sortable: true,
            align: "center",
        });
    }
    if (viewSettings.showTransfers) {
        columns.push({
            key: "transfers",
            label: "Transfers",
            sortable: true,
            align: "center",
        });
    }
    if (viewSettings.showIsBackup) {
        columns.push({
            key: "isBackup",
            label: "Is Backup",
            sortable: true,
            align: "center",
        });
    }
    if (viewSettings.showIsForward) {
        columns.push({
            key: "isForward",
            label: "Is Forward",
            sortable: true,
            align: "center",
        });
    }
    if (kpiResult) {
        columns.push({
            key: "kpiExcellent",
            label: `KPI <${kpiResult.kpiConfig.thresholds.excellent || 5}m`,
            sortable: true,
            align: "center",
            render: (_, row) => `${row.kpiExcellentPercent || "0%"} (${row.kpiExcellent || 0})`,
        }, {
            key: "kpiGood",
            label: `KPI <${kpiResult.kpiConfig.thresholds.good || 15}m`,
            sortable: true,
            align: "center",
            render: (_, row) => `${row.kpiGoodPercent || "0%"} (${row.kpiGood || 0})`,
        }, {
            key: "kpiAcceptable",
            label: `KPI <${kpiResult.kpiConfig.thresholds.acceptable || 30}m`,
            sortable: true,
            align: "center",
            render: (_, row) => `${row.kpiAcceptablePercent || "0%"} (${row.kpiAcceptable || 0})`,
        }, {
            key: "kpiPoor",
            label: `KPI >${kpiResult.kpiConfig.thresholds.acceptable || 30}m`,
            sortable: true,
            align: "center",
            render: (_, row) => `${row.kpiPoorPercent || "0%"} (${row.kpiPoor || 0})`,
        });
    }
    return columns;
};
//# sourceMappingURL=ExecutiveSummaryColumns.js.map